import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';
import { ProductPrice } from '../domains-product/product-prices';

@Injectable({
  providedIn: 'root'
})
export class SrvProductPriceService {
  private url = 'product_api/product_prices/';

  constructor(private http: HttpClient) {}

  private getHeaders(): HttpHeaders {
    return new HttpHeaders({ 'Content-Type': 'application/json' });
  }

  // Obtener todos los precios o filtrar por status
  getProductPrices(status?: number): Observable<ProductPrice[]> {
    const query = status !== undefined ? `?status=${status}` : '';
    const url = `${environment.url_web_services_path}${this.url}${query}`;
    return this.http.get<ProductPrice[]>(url, { headers: this.getHeaders() });
  }

  // Crear un nuevo precio
  createPrice(price: ProductPrice): Observable<ProductPrice> {
    const url = `${environment.url_web_services_path}${this.url}`;
    return this.http.post<ProductPrice>(url, price, { headers: this.getHeaders() });
  }

  // Actualizar un precio existente
  updatePrice(price: ProductPrice): Observable<ProductPrice> {
    const url = `${environment.url_web_services_path}${this.url}${price.rowid}/`;
    return this.http.put<ProductPrice>(url, price, { headers: this.getHeaders() });
  }

  // Eliminar (soft delete) un precio
  deletePrice(rowid: number): Observable<any> {
    const url = `${environment.url_web_services_path}${this.url}${rowid}/`;
    return this.http.delete(url, { headers: this.getHeaders() });
  }
}
